import script from "./RelapsePreventionPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./RelapsePreventionPlan.vue?vue&type=script&setup=true&lang=js"

import "./RelapsePreventionPlan.vue?vue&type=style&index=0&id=67e34505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e34505"]])

export default __exports__